(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[568],{

/***/ 3303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.847 2.179a.52.52 0 0 1 0 .739L4.543 10.22a.52.52 0 0 1-.738 0L.153 6.569a.522.522 0 1 1 .739-.738l3.282 3.283 6.934-6.935a.52.52 0 0 1 .739 0"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgCheck);

/***/ }),

/***/ 66097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgSecurity = function SvgSecurity(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#0D5284",
    d: "M.133 1.733H11.96l3.2 5.334h16.707V27.2a3.067 3.067 0 0 1-2.95 3.064l-.117.003h-4.667v-.8H28.8a2.267 2.267 0 0 0 2.264-2.157l.003-.11V7.867h-16.36l-3.2-5.334H.933V27.2c0 1.215.956 2.207 2.157 2.264l.11.003h4.667v.8H3.2a3.067 3.067 0 0 1-3.064-2.95L.133 27.2z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#FF6D5E",
    d: "M21.733 22v8.267H10.267V22zm-.8.8h-9.866v6.667h9.866zM16 25.2a.933.933 0 1 1 0 1.867.933.933 0 0 1 0-1.867M16 14a3.6 3.6 0 0 1 3.598 3.474l.002.126v2.533h-.8V17.6a2.8 2.8 0 0 0-5.598-.115l-.002.115v2.533h-.8V17.6A3.6 3.6 0 0 1 16 14"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgSecurity);

/***/ }),

/***/ 86515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgVideos = function SvgVideos(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#0D5284",
    d: "M28.908 7.197c1.707 0 3.092 1.397 3.092 3.121v18.56C32 30.603 30.615 32 28.908 32H3.092C1.385 32 0 30.602 0 28.879v-18.56c0-1.725 1.385-3.122 3.092-3.122Zm0 .814H3.092a2.296 2.296 0 0 0-2.285 2.307v18.56a2.296 2.296 0 0 0 2.285 2.308h25.816a2.296 2.296 0 0 0 2.285-2.307v-18.56a2.296 2.296 0 0 0-2.285-2.308M28.1 3.598v1.01H3.899v-1.01h24.202ZM24.759 0v1.01H7.24V0h17.52Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#FF6D5E",
    d: "M13.369 14.011v11.174l7.783-5.587zm.806 1.579 5.585 4.008-5.585 4.009z"
  }))));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgVideos);

/***/ }),

/***/ 22763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ video_cdn; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(21548);
// EXTERNAL MODULE: ./src/components/CtaPanel/CtaPanel.tsx
var CtaPanel = __webpack_require__(22316);
// EXTERNAL MODULE: ./src/components/FaqSection/FaqSection.tsx + 3 modules
var FaqSection = __webpack_require__(67645);
// EXTERNAL MODULE: ./src/components/Feature/Feature.tsx
var Feature = __webpack_require__(41657);
// EXTERNAL MODULE: ./src/siteData.ts
var siteData = __webpack_require__(97992);
;// CONCATENATED MODULE: ./src/components/Images/Icons/costReduction.svg
var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgCostReduction = function SvgCostReduction(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "#FF6D5E",
    d: "M12.804 25.598a6.402 6.402 0 1 1-12.804 0 6.402 6.402 0 0 1 12.804 0m-.807 0a5.595 5.595 0 1 0-11.19 0 5.595 5.595 0 0 0 11.19 0M32 6.402a6.402 6.402 0 1 1-12.804 0 6.402 6.402 0 0 1 12.804 0m-.807 0a5.595 5.595 0 1 0-11.19 0 5.595 5.595 0 0 0 11.19 0"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#0D5284",
    d: "m31.996 19.545.004.054v11.998l-.002.037-.009.055-.01.036-.031.07-.03.044-.036.043a.4.4 0 0 1-.06.049l-.05.03-.047.018-.074.017-.054.004H19.599a.403.403 0 0 1-.055-.803l.055-.004h11.024L.118.689a.403.403 0 0 1 .525-.61L.69.12l30.504 30.504V19.599c0-.204.152-.373.349-.4l.055-.003c.204 0 .373.152.4.348"
  })));
};
/* harmony default export */ var costReduction = (SvgCostReduction);
// EXTERNAL MODULE: ./src/components/Images/Icons/peak.svg
var peak = __webpack_require__(37863);
// EXTERNAL MODULE: ./src/components/Images/Icons/security.svg
var security = __webpack_require__(66097);
;// CONCATENATED MODULE: ./src/components/Images/Icons/videoFeatures.svg
var _g;
function videoFeatures_extends() { return videoFeatures_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, videoFeatures_extends.apply(null, arguments); }

var SvgVideoFeatures = function SvgVideoFeatures(props) {
  return /*#__PURE__*/react.createElement("svg", videoFeatures_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#FF6D5E",
    d: "M31.867 28.443v.8H21.629v-.8zm0-4.719v.8H21.629v-.8zm0-4.719v.8H21.629v-.8z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#0D5284",
    d: "M21.298 1.045A15.87 15.87 0 0 1 31.865 15.77l.002.226v.4h-.8v-.4a15.066 15.066 0 1 0-12.17 14.789l.22-.045.392-.083.165.783-.391.082a15.867 15.867 0 1 1 2.015-30.477M11.144 9.813l10.66 5.922-10.66 5.923zm.8 1.359v9.126l8.213-4.563-8.214-4.563Z"
  }))));
};
/* harmony default export */ var videoFeatures = (SvgVideoFeatures);
// EXTERNAL MODULE: ./src/components/Images/Icons/videos.svg
var videos = __webpack_require__(86515);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Feature/features.tsx








var networkCapacityFeature = {
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(peak/* default */.Z, {}),
  title: "".concat(siteData/* cdnStats.capacity.network */.MZ.capacity.network, " network"),
  description: 'Experience lightning-fast content delivery with our robust global network, which has a private backbone connected to top-tier ISPs.'
};
var videoCdnFeature = {
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(videos/* default */.Z, {}),
  title: 'CDN optimized for video',
  description: 'Multi-layer caching systems, latency-based routing, delivery of all major HTTP video formats to any device.'
};
var costReductionFeature = {
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(costReduction, {}),
  title: 'Egress cost reduction',
  description: "CDN77 Storage and customized cache rules improve cache hit ratio to ".concat(siteData/* cdnStats.avgCacheHit */.MZ.avgCacheHit, " or higher & reduce bandwidth costs.")
};
var securityFeature = {
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(security/* default */.Z, {}),
  title: 'Security & content protection',
  description: 'Proprietary DDoS protection, Secure Tokens, IP & Geo-blocking, SSL, Multi‑DRM and more.'
};
var additionalVideoFeaturesFeature = {
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(videoFeatures, {}),
  title: 'Additional video features',
  description: 'Encoding, transcoding, DVR & Timeshift, HTML5 player with audience analytics.'
};
// EXTERNAL MODULE: ./src/components/Image/Image.tsx
var Image = __webpack_require__(41289);
// EXTERNAL MODULE: ./src/components/Layout/Col/Col.tsx
var Col = __webpack_require__(45083);
// EXTERNAL MODULE: ./src/components/Layout/Head.tsx
var Head = __webpack_require__(15934);
// EXTERNAL MODULE: ./src/components/Layout/Row/Row.tsx
var Row = __webpack_require__(16220);
// EXTERNAL MODULE: ./src/components/LogosRow/LogosRow.tsx
var LogosRow = __webpack_require__(91546);
// EXTERNAL MODULE: ./src/components/Layout/Container/Container.tsx
var Container = __webpack_require__(59339);
// EXTERNAL MODULE: ./src/components/MessageBar/MessageBar.module.scss
var MessageBar_module = __webpack_require__(41029);
var MessageBar_module_default = /*#__PURE__*/__webpack_require__.n(MessageBar_module);
;// CONCATENATED MODULE: ./src/components/MessageBar/MessageBar.tsx




var MessageBar = function MessageBar(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (MessageBar_module_default()).wrapper,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* Container */.W, {
      children: children
    })
  });
};
// EXTERNAL MODULE: ./src/components/Paragraph/Paragraph.tsx
var Paragraph = __webpack_require__(34687);
// EXTERNAL MODULE: ./src/components/ReviewsCarousel/ReviewsCarousel.tsx + 1 modules
var ReviewsCarousel = __webpack_require__(23514);
// EXTERNAL MODULE: ./src/components/ReviewsCarousel/reviewsData.tsx + 1 modules
var reviewsData = __webpack_require__(72966);
// EXTERNAL MODULE: ./src/components/Section/Section.tsx
var Section = __webpack_require__(34049);
// EXTERNAL MODULE: ./src/components/SmallTitle/SmallTitle.tsx
var SmallTitle = __webpack_require__(88358);
// EXTERNAL MODULE: ./src/components/Text/Text.tsx
var Text = __webpack_require__(40426);
// EXTERNAL MODULE: ./src/routes.ts
var routes = __webpack_require__(20925);
// EXTERNAL MODULE: ./src/components/Pages/VideoCdn/VideoCdn.module.scss
var VideoCdn_module = __webpack_require__(49661);
var VideoCdn_module_default = /*#__PURE__*/__webpack_require__.n(VideoCdn_module);
// EXTERNAL MODULE: ./src/components/Pages/VideoCdn/hero.png
var hero = __webpack_require__(67137);
var hero_default = /*#__PURE__*/__webpack_require__.n(hero);
// EXTERNAL MODULE: ./src/components/Pages/VideoCdn/html5-player.png
var html5_player = __webpack_require__(78966);
var html5_player_default = /*#__PURE__*/__webpack_require__.n(html5_player);
// EXTERNAL MODULE: ./src/components/Pages/VideoCdn/ls-processing.png
var ls_processing = __webpack_require__(72570);
var ls_processing_default = /*#__PURE__*/__webpack_require__.n(ls_processing);
// EXTERNAL MODULE: ./src/components/Pages/VideoCdn/vod-workflow.png
var vod_workflow = __webpack_require__(31608);
var vod_workflow_default = /*#__PURE__*/__webpack_require__.n(vod_workflow);
// EXTERNAL MODULE: ./src/components/Images/Logos/Colored/banijay.svg
var banijay = __webpack_require__(64533);
// EXTERNAL MODULE: ./src/components/Images/Logos/Colored/rakuten.svg
var rakuten = __webpack_require__(24682);
// EXTERNAL MODULE: ./src/components/Images/Logos/Colored/sport1.svg
var sport1 = __webpack_require__(37838);
// EXTERNAL MODULE: ./src/components/Images/Logos/Colored/starz.svg
var starz = __webpack_require__(48550);
// EXTERNAL MODULE: ./src/components/Images/Logos/Colored/udemy.svg
var udemy = __webpack_require__(29847);
;// CONCATENATED MODULE: ./src/components/Pages/VideoCdn/VideoCdn.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



































var cx = bind_default().bind((VideoCdn_module_default()));
var VideoCdn = function VideoCdn() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      description: "Deliver high-quality video streaming at scale across all platforms & devices. Robust ".concat(siteData/* cdnStats.capacity.network */.MZ.capacity.network, " network that easily handles unexpected traffic spikes."),
      title: "Video CDN for VOD & live video platforms"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section/* Section */.$, {
      padding: 120,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* Row */.X, {
        className: "mb-8",
        verticalAlign: "center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Col/* Col */.J, {
          lg: 6,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* Text */.x, {
            align: "left",
            className: "mb-4",
            color: "gray900",
            isBalanced: false,
            size: 56,
            tag: "h1",
            weight: "regular",
            children: ["CDN optimized for ", /*#__PURE__*/(0,jsx_runtime.jsx)("b", {
              children: "VOD and live video platforms"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
            maxWidth: 470,
            size: "xl",
            children: "MP4/HLS/MPEG-DASH/CMAF playback support for all platforms and devices."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* Col */.J, {
          lg: 6,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, {
            alt: "",
            height: 390,
            src: (hero_default()),
            width: 577,
            priority: true
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LogosRow/* LogosRow */.H, {
        logos: [{
          src: starz,
          name: 'Starz',
          width: 85,
          height: 25
        }, {
          src: rakuten,
          name: 'Rakuten',
          width: 85,
          height: 27
        }, {
          src: udemy,
          name: 'Udemy',
          width: 81,
          height: 30
        }, {
          src: banijay,
          name: 'Banijay',
          width: 90,
          height: 25
        }, {
          src: sport1,
          name: 'Sport 1',
          width: 79,
          height: 23
        }],
        note: "Trusted by"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("main", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Section/* Section */.$, {
        padding: 150,
        theme: "tiles",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* Text */.x, {
          align: "center",
          className: "mb-4",
          color: "gray900",
          display: "block",
          isBalanced: false,
          maxWidth: 560,
          size: 44,
          tag: "h2",
          isCentered: true,
          children: ["Global delivery of all major ", /*#__PURE__*/(0,jsx_runtime.jsx)("b", {
            children: "HTTP video formats"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Paragraph/* Paragraph */.n, {
          align: "center",
          className: "mb-8",
          maxWidth: 580,
          size: "lg",
          isCentered: true,
          children: ["With ", siteData/* cdnStats.capacity.network */.MZ.capacity.network, " network capacity and PoPs across", ' ', siteData/* cdnStats.continentsCount */.MZ.continentsCount, "\xA0continents, CDN77 secures the highest speed\xA0&\xA0smooth delivery of live and on-demand videos, no matter where your viewers are."]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mw-7 mx-auto",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Row/* Row */.X, {
            gapX: "xl",
            gapY: "xl",
            children: [videoCdnFeature, costReductionFeature, securityFeature, additionalVideoFeaturesFeature].map(function (feature) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* Col */.J, {
                gapX: "xl",
                gapY: "xl",
                md: 6,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Feature/* Feature */.L, _objectSpread(_objectSpread({}, feature), {}, {
                  maxWidth: 320
                }))
              }, feature.title);
            })
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section/* Section */.$, {
        overflow: "hidden",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
          align: "center",
          className: "mb-7",
          color: "gray900",
          display: "block",
          size: 30,
          tag: "h2",
          weight: "bold",
          children: "How satisfied clients are with CDN77"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ReviewsCarousel/* ReviewsCarousel */.i, {
          data: [reviewsData/* reviewStarz */.hw, reviewsData/* reviewRakuten */.kX, reviewsData/* reviewUdemy */.v$, reviewsData/* reviewSport1 */.cV, reviewsData/* reviewBanijay */.Ho]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CtaPanel/* CtaPanel */.a, {
        title: "Put your viewers in the front row."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section/* Section */.$, {
        padding: {
          top: 150,
          bottom: 120
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SmallTitle/* SmallTitle */.h, {
          color: "gray",
          children: "Additional video features"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
          align: "center",
          color: "gray900",
          display: "block",
          size: 44,
          tag: "h2",
          children: "Accelerate your video workflow"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Section/* Section */.$, {
          padding: {
            top: 120,
            bottom: 150
          },
          tag: "div",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* Row */.X, {
            className: (VideoCdn_module_default()).row,
            horizontalAlign: "between",
            verticalAlign: "center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Col/* Col */.J, {
              lg: 5,
              md: 7,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
                align: "left",
                className: "mb-3",
                color: "gray900",
                size: 30,
                tag: "h3",
                weight: "bold",
                children: "VOD workflow"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                maxWidth: 380,
                size: "lg",
                children: "Upload your prerecorded videos to our CDN Storage and let it become your origin. Create files through API-based transcoding and serve them via CDN in formats of your choice."
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* Col */.J, {
              className: (VideoCdn_module_default()).imageWrapper,
              lg: 7,
              md: 5,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, {
                alt: "Bradmax HTML5 player",
                height: 300,
                src: (vod_workflow_default()),
                width: 557
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Section/* Section */.$, {
          borderRadius: "rounded",
          padding: 90,
          tag: "div",
          theme: "dark",
          isPulled: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* Row */.X, {
            className: cx('row', 'isReversed'),
            verticalAlign: "center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Col/* Col */.J, {
              lg: 5,
              md: 7,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
                align: "left",
                className: "mb-3",
                color: "white",
                size: 30,
                tag: "h3",
                weight: "bold",
                children: "Live streaming processing"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                color: "light",
                maxWidth: 380,
                opacity: 80,
                size: "lg",
                children: "Send us your live stream over standard protocols (RTMP, RTSP, HLS, MPEG-DASH, MPEG-TS) and let us convert and transcode your video to optimize viewer experience."
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* Col */.J, {
              lg: 7,
              md: 5,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, {
                alt: "Bradmax HTML5 player",
                height: 375,
                src: (ls_processing_default()),
                width: 560
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Section/* Section */.$, {
          padding: {
            top: 150,
            bottom: 0
          },
          tag: "div",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* Row */.X, {
            className: (VideoCdn_module_default()).row,
            horizontalAlign: "between",
            verticalAlign: "center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Col/* Col */.J, {
              lg: 5,
              md: 7,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
                align: "left",
                className: "mb-3",
                color: "gray900",
                size: 30,
                tag: "h3",
                weight: "bold",
                children: "HTML5 player"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
                maxWidth: 380,
                size: "lg",
                children: "On the frontend side, you can enhance your viewer experience with a fully customisable HTML5 player equipped with audience analytics which is available for both web and mobile application."
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* Col */.J, {
              className: (VideoCdn_module_default()).imageWrapper,
              lg: 7,
              md: 5,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, {
                alt: "Bradmax HTML5 player",
                height: 399,
                src: (html5_player_default()),
                width: 515
              })
            })]
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MessageBar, {
        children: ["Prices for additional video features are customized.", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* Button */.z, {
          className: (VideoCdn_module_default()).link,
          href: routes/* routes.getStarted */._j.getStarted,
          children: "Talk to sales"
        }), ' ', "about your specific needs."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section/* Section */.$, {
        padding: 150,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
          align: "center",
          className: "mb-8",
          color: "gray900",
          display: "block",
          size: 44,
          tag: "h2",
          children: "Frequently asked questions"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FaqSection/* FaqSection */.o, {
          data: [{
            question: 'Where can I find pricing information?',
            answer: "At CDN77, we've learned that one size doesn't fit all. Every client has unique requirements when it comes to video streaming services. Simply contact us describing your use case and we'll be happy to send you custom pricing."
          }, {
            question: 'How can you protect my video content?',
            answer: "We offer a <a href=\"".concat(routes/* externalRoutes.client.securityMeasure */.jY.client.securityMeasure, "\">range of features</a> to help you secure access to your content in every scenario imaginable. Whitelist & blacklist by geographical region and IP address, hotlink protection (domain lock), secure tokens as well as custom multi-DRM integrations using the following encryption keys  - PlayReady and Widevine (MPEG-DASH) and FairPlay (HLS). We also develop our own proprietary Hurricane\xAE DDoS protection which mitigates outside attacks in under 10 seconds.")
          }, {
            question: 'Can I host my VOD library at CDN77?',
            answer: "Of course! Once you upload your files into the <a href=\"".concat(routes/* externalRoutes.client.cdnStorage */.jY.client.cdnStorage, "\">CDN77 Object Storage</a> it becomes your origin. Your content will be delivered worldwide in the most efficient way while decreasing the number of load requests.")
          }, {
            question: 'Does CDN77 have a video player?',
            answer: 'Yes we cooperate with Bradmax player to enhance the playback experience on your front-end. It comes along with a vast range of audience analytics such as the number of real-time views, users, geolocation, device overview, engagement rate, and many others.'
          } // {
          //   question: 'Can CDN77 help with IPTV/OTT delivery?',
          //   answer:
          //     "Absolutely! We can help with the complete process from signal ingestion to a fully customized player. With CDN77 you can bring your entire video processing workflow under one roof. In fact, we've already helped many traditional TV broadcasters in setting up their end-to-end live streaming & VOD solution for their digital projects.",
          // },
          ],
          isCtaVisible: false,
          openFirstItem: true
        })]
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./pages/video-cdn.ts

/* harmony default export */ var video_cdn = (VideoCdn);

/***/ }),

/***/ 22316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ CtaPanel; }
/* harmony export */ });
/* harmony import */ var _builds_purple_team_cdn77_frontend_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _builds_purple_team_cdn77_frontend_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4730);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _CtaPanelWrapper_CtaPanelWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20813);
/* harmony import */ var _components_Button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21548);
/* harmony import */ var _components_Paragraph_Paragraph__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34687);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20925);
/* harmony import */ var _CtaPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61676);
/* harmony import */ var _CtaPanel_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_CtaPanel_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);
'use client';



var _excluded = ["title"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_purple_team_cdn77_frontend_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_CtaPanel_module_scss__WEBPACK_IMPORTED_MODULE_8___default()));
var CtaPanel = function CtaPanel(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Deliver your content with CDN77' : _ref$title,
      text = _ref.text,
      _ref$buttons = _ref.buttons,
      buttons = _ref$buttons === void 0 ? [{
    title: 'Talk to sales',
    href: _routes__WEBPACK_IMPORTED_MODULE_6__/* .routes.getStarted */ ._j.getStarted,
    id: 'cta-contact'
  }] : _ref$buttons,
      children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_CtaPanelWrapper_CtaPanelWrapper__WEBPACK_IMPORTED_MODULE_3__/* .CtaPanelWrapper */ .U, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("h2", {
      className: cx('title', text ? 'mb-2' : 'mb-5'),
      children: title
    }), text && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_Paragraph_Paragraph__WEBPACK_IMPORTED_MODULE_5__/* .Paragraph */ .n, {
      align: "center",
      className: "mb-5",
      color: "light",
      opacity: 60,
      size: "lg",
      children: text
    }), children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
      className: (_CtaPanel_module_scss__WEBPACK_IMPORTED_MODULE_8___default().buttonsWrapper),
      children: buttons.map(function (_ref2, index) {
        var title = _ref2.title,
            rest = (0,_builds_purple_team_cdn77_frontend_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_ref2, _excluded);

        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, _objectSpread(_objectSpread({
          className: (_CtaPanel_module_scss__WEBPACK_IMPORTED_MODULE_8___default().button),
          theme: "button",
          variant: index === 0 ? 'primary' : 'inverted'
        }, rest), {}, {
          children: title
        }), typeof title === 'string' ? "".concat(title, "-").concat(index) : index);
      })
    })]
  });
};

/***/ }),

/***/ 20813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ CtaPanelWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Image/Image.tsx
var Image = __webpack_require__(41289);
// EXTERNAL MODULE: ./src/components/Layout/Container/Container.tsx
var Container = __webpack_require__(59339);
// EXTERNAL MODULE: ./src/components/Section/Section.tsx
var Section = __webpack_require__(34049);
// EXTERNAL MODULE: ./src/components/CtaPanel/CtaPanelWrapper/CtaPanelWrapper.module.scss
var CtaPanelWrapper_module = __webpack_require__(19630);
var CtaPanelWrapper_module_default = /*#__PURE__*/__webpack_require__.n(CtaPanelWrapper_module);
// EXTERNAL MODULE: ./src/components/CtaPanel/CtaPanelWrapper/cta-globe.png
var cta_globe = __webpack_require__(39582);
var cta_globe_default = /*#__PURE__*/__webpack_require__.n(cta_globe);
;// CONCATENATED MODULE: ./src/components/CtaPanel/CtaPanelWrapper/cta-lines.svg
var cta_lines_namespaceObject = __webpack_require__.p + "static/media/cta-lines.d57745a7.svg";
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/CtaPanel/CtaPanelWrapper/CtaPanelWrapper.tsx
'use client';










var CtaPanelWrapper = function CtaPanelWrapper(_ref) {
  var _ref$background = _ref.background,
      background = _ref$background === void 0 ? 'globe' : _ref$background,
      className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Section/* Section */.$, {
    overflow: "hidden",
    padding: 0,
    withContainer: false,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* Container */.W, {
      className: className,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Section/* Section */.$, {
        borderRadius: "rounded",
        className: (CtaPanelWrapper_module_default()).section,
        padding: 90,
        isPulled: true,
        children: [background === 'globe' && /*#__PURE__*/(0,jsx_runtime.jsx)("figure", {
          className: (CtaPanelWrapper_module_default()).background,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, {
            alt: "",
            height: 569,
            src: (cta_globe_default()),
            width: 569
          })
        }), background === 'lines' && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          alt: "",
          className: (CtaPanelWrapper_module_default()).linesBackground,
          height: 855,
          src: cta_lines_namespaceObject,
          width: 1110
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (CtaPanelWrapper_module_default()).content,
          children: children
        })]
      })
    })
  });
};

/***/ }),

/***/ 67645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ FaqSection; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/FaqSection/Faq/FaqStructuredData.tsx




var getText = function getText(text) {
  if (typeof text === 'string') {
    return text;
  }

  if (Array.isArray(text)) {
    return text.map(getText).join(' ');
  }

  return text.simple;
};

var removeHtmlTags = function removeHtmlTags(text) {
  return text.replace(/<[^>]*>?/gm, '');
};

var structuredJSON = function structuredJSON(data) {
  return "{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [".concat(data.map(function (_ref) {
    var question = _ref.question,
        answer = _ref.answer;
    return "{\n    \"@type\": \"Question\",\n    \"name\": \"".concat(question, "\",\n    \"acceptedAnswer\": {\"@type\": \"Answer\",\"text\": ").concat(JSON.stringify(removeHtmlTags(getText(answer))), "}\n  }");
  }), "]\n}");
};

var FaqStructuredData = function FaqStructuredData(_ref2) {
  var data = _ref2.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML: {
        __html: structuredJSON(data)
      } // eslint-disable-next-line react/no-danger
      ,
      type: "application/ld+json"
    })
  });
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./src/components/List/List.tsx + 1 modules
var List = __webpack_require__(15535);
// EXTERNAL MODULE: ./src/components/Text/Text.tsx
var Text = __webpack_require__(40426);
// EXTERNAL MODULE: ./src/gaEvents.ts
var gaEvents = __webpack_require__(27751);
// EXTERNAL MODULE: ./src/components/FaqSection/Faq/QuestionBox/QuestionBox.module.scss
var QuestionBox_module = __webpack_require__(12743);
var QuestionBox_module_default = /*#__PURE__*/__webpack_require__.n(QuestionBox_module);
// EXTERNAL MODULE: ./src/components/Images/Icons/angleDown.svg
var angleDown = __webpack_require__(18366);
;// CONCATENATED MODULE: ./src/components/FaqSection/Faq/QuestionBox/QuestionBox.tsx










var cx = bind_default().bind((QuestionBox_module_default()));
var QuestionBox = function QuestionBox(_ref) {
  var index = _ref.index,
      answer = _ref.answer,
      question = _ref.question,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type,
      openOnLoad = _ref.openOnLoad;

  var _React$useState = react.useState(openOnLoad),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      isVisible = _React$useState2[0],
      setIsVisible = _React$useState2[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: cx('wrapper', type, {
      isVisible: isVisible
    }),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
        "aria-controls": "faq-question-".concat(index),
        "aria-expanded": isVisible,
        className: (QuestionBox_module_default()).question,
        id: "faq-answer-".concat(index),
        type: "button",
        onClick: function onClick() {
          if (!isVisible) {
            (0,gaEvents/* trackClickEvent */.uH)(question, 'faq');
          }

          setIsVisible(!isVisible);
        },
        children: [question, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (QuestionBox_module_default()).iconWrapper,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(angleDown/* default */.Z, {
            className: (QuestionBox_module_default()).icon
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
      "aria-labelledby": "faq-answer-".concat(index),
      className: (QuestionBox_module_default()).answer,
      id: "faq-question-".concat(index),
      children: Array.isArray(answer) ? answer.map(function (text, index) {
        if (Array.isArray(text)) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(List/* List */.a, {
            items: text.map(function (item) {
              return typeof item === 'string' ? item : item.render;
            }),
            ulClassName: cx({
              'mb-4': index !== answer.length - 1
            })
          }, typeof text[0] === 'string' ? text[0] : text[0].simple);
        }

        return /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
          className: cx({
            'mb-4': index !== answer.length - 1
          }),
          dangerouslySetInnerHTML: typeof text === 'string' ? {
            __html: text
          } : undefined,
          tag: "p",
          children: typeof text !== 'string' ? text.render : null
        }, typeof text === 'string' ? text : text.simple);
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
        dangerouslySetInnerHTML: typeof answer === 'string' ? {
          __html: answer
        } : undefined,
        tag: "p",
        children: typeof answer !== 'string' ? answer.render : null
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/FaqSection/Faq/Faq.tsx






var Faq = function Faq(_ref) {
  var data = _ref.data,
      openFirstItem = _ref.openFirstItem;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaqStructuredData, {
      data: data
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("dl", {
      className: "mb-0",
      children: data.map(function (_ref2, index) {
        var question = _ref2.question,
            answer = _ref2.answer;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(QuestionBox, {
          answer: answer,
          index: index,
          openOnLoad: openFirstItem && index === 0,
          question: question,
          type: "lg"
        }, question);
      })
    })]
  });
};
// EXTERNAL MODULE: ./src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(21548);
// EXTERNAL MODULE: ./src/routes.ts
var routes = __webpack_require__(20925);
// EXTERNAL MODULE: ./src/components/FaqSection/FaqSection.module.scss
var FaqSection_module = __webpack_require__(79320);
var FaqSection_module_default = /*#__PURE__*/__webpack_require__.n(FaqSection_module);
;// CONCATENATED MODULE: ./src/components/FaqSection/FaqSection.tsx








var FaqSection = function FaqSection(_ref) {
  var data = _ref.data,
      openFirstItem = _ref.openFirstItem,
      _ref$isCtaVisible = _ref.isCtaVisible,
      isCtaVisible = _ref$isCtaVisible === void 0 ? true : _ref$isCtaVisible;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (FaqSection_module_default()).faqWrapper,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (FaqSection_module_default()).faq,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Faq, {
        data: data,
        openFirstItem: openFirstItem
      })
    }), isCtaVisible && /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* Text */.x, {
      size: 14,
      tag: "p",
      children: ["Haven\u2019t found an answer to your question? Visit our", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* Button */.z, {
        href: routes/* externalRoutes.client.support */.jY.client.support,
        external: true,
        noIcon: true,
        children: "Help center"
      }), ' ', "or ", /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* Button */.z, {
        href: routes/* routes.contact */._j.contact,
        children: "contact us"
      }), "."]
    })]
  });
};

/***/ }),

/***/ 41657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Feature; }
/* harmony export */ });
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Text_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40426);
/* harmony import */ var _Feature_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69993);
/* harmony import */ var _Feature_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Feature_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_0___default().bind((_Feature_module_scss__WEBPACK_IMPORTED_MODULE_4___default()));
var Feature = function Feature(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      description = _ref.description,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'dark' : _ref$color,
      maxWidth = _ref.maxWidth,
      _ref$iconMargin = _ref.iconMargin,
      iconMargin = _ref$iconMargin === void 0 ? 'md' : _ref$iconMargin;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    className: cx('wrapper', color),
    style: {
      maxWidth: maxWidth !== null && maxWidth !== void 0 ? maxWidth : 290
    },
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: cx('iconWrapper', iconMargin),
      children: icon
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: (_Feature_module_scss__WEBPACK_IMPORTED_MODULE_4___default().content),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_Text_Text__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
        className: (_Feature_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
        size: 20,
        tag: "strong",
        children: title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_Text_Text__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
        align: "center",
        className: (_Feature_module_scss__WEBPACK_IMPORTED_MODULE_4___default().description),
        color: color === 'dark' ? 'gray500' : 'white',
        opacity: color === 'dark' ? 100 : 80,
        size: 16,
        tag: "div",
        children: description
      })]
    })]
  });
};

/***/ }),

/***/ 15934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20925);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
var _process$env$NEXT_PUB;








var APP_URL = (_process$env$NEXT_PUB = "https://www.cdn77.com") !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : '';
var Head = function Head(_ref) {
  var description = _ref.description,
      title = _ref.title,
      noIndex = _ref.noIndex,
      canonical = _ref.canonical,
      ogUrl = _ref.ogUrl,
      imageOg = _ref.imageOg,
      imageTwitter = _ref.imageTwitter,
      children = _ref.children;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
      content: "width=device-width, initial-scale=1",
      name: "viewport"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("title", {
      children: "".concat(title, " | CDN77.com")
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
      content: ogUrl ? "".concat(APP_URL.replace(/\/+$/, '')).concat(ogUrl) : router && "".concat(APP_URL.replace(/\/+$/, '')).concat(router && router.pathname !== '/' ? router.pathname : ''),
      property: "og:url"
    }), description && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        content: description.replace(/\s\s+/g, ' '),
        name: "description"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        content: description.replace(/\s\s+/g, ' '),
        property: "og:description"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        content: description.replace(/\s\s+/g, ' '),
        name: "twitter:description"
      })]
    }), noIndex ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
      content: "noindex, follow",
      name: "robots"
    }) : router && router.pathname !== '_error' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("link", {
      href: canonical ? "".concat(APP_URL.replace(/\/+$/, '')).concat(canonical) : router && "".concat(APP_URL.replace(/\/+$/, '')).concat(router.pathname !== '/' ? router.pathname : ''),
      rel: "canonical"
    }), router && ![_routes__WEBPACK_IMPORTED_MODULE_3__/* .routes.tlsTest */ ._j.tlsTest].includes(router.pathname) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        content: "".concat(title, " | CDN77.com"),
        property: "og:title"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        content: "".concat(title, " | CDN77.com"),
        name: "twitter:title"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        content: "summary",
        name: "twitter:card"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        content: imageOg !== null && imageOg !== void 0 ? imageOg : 'https://www.cdn77.com/open-graph.png',
        property: "og:image"
      }), imageOg && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        content: "1200",
        property: "og:image:width"
      }), imageOg && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        content: "628",
        property: "og:image:height"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("meta", {
        content: imageTwitter !== null && imageTwitter !== void 0 ? imageTwitter : 'https://www.cdn77.com/open-graph.png',
        name: "twitter:image"
      })]
    }), children]
  });
};

/***/ }),

/***/ 15535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ List; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/List/ListBullet/ListBullet.module.scss
var ListBullet_module = __webpack_require__(12868);
var ListBullet_module_default = /*#__PURE__*/__webpack_require__.n(ListBullet_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/List/ListBullet/ListBullet.tsx




var cx = bind_default().bind((ListBullet_module_default()));
var ListBullet = function ListBullet(_ref) {
  var size = _ref.size,
      type = _ref.type,
      color = _ref.color,
      shape = _ref.shape;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: cx(type, shape, color),
    style: {
      width: size === 'auto' ? '0.3em' : size,
      height: size === 'auto' ? '0.3em' : size
    }
  });
};
// EXTERNAL MODULE: ./src/components/Icon/Icon.tsx
var Icon = __webpack_require__(37078);
// EXTERNAL MODULE: ./src/components/Text/Text.tsx
var Text = __webpack_require__(40426);
// EXTERNAL MODULE: ./src/components/List/List.module.scss
var List_module = __webpack_require__(48543);
var List_module_default = /*#__PURE__*/__webpack_require__.n(List_module);
// EXTERNAL MODULE: ./src/components/Images/Icons/check.svg
var check = __webpack_require__(3303);
;// CONCATENATED MODULE: ./src/components/List/List.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var List_cx = bind_default().bind((List_module_default()));
var List = function List(_ref) {
  var _ref2;

  var _ref$type = _ref.type,
      Tag = _ref$type === void 0 ? 'ul' : _ref$type,
      _ref$bullet = _ref.bullet,
      bullet = _ref$bullet === void 0 ? {
    size: 'auto',
    shape: 'circle',
    type: 'filled',
    color: 'black'
  } : _ref$bullet,
      items = _ref.items,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'inherit' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'inherit' : _ref$color,
      _ref$opacity = _ref.opacity,
      opacity = _ref$opacity === void 0 ? 100 : _ref$opacity,
      align = _ref.align,
      _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? 20 : _ref$gap,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 24 : _ref$padding,
      _ref$line = _ref.line,
      line = _ref$line === void 0 ? 'none' : _ref$line,
      ulClassName = _ref.ulClassName,
      liClassName = _ref.liClassName;
  var finalBullet = react.useMemo(function () {
    if (Tag === 'ol') {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (List_module_default()).counter
      });
    }

    if (bullet === 'check') {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* Icon */.J, {
        color: "blue200",
        size: size === 'inherit' ? 12 : Math.floor(size * 0.75),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(check/* default */.Z, {})
      });
    }

    if ('type' in bullet && 'color' in bullet && 'shape' in bullet && 'size' in bullet) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ListBullet, _objectSpread({}, bullet));
    }

    return bullet;
  }, [Tag, bullet]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Tag, {
    className: List_cx('list', ulClassName, {
      withSeparator: line !== 'none' && items.length > 1
    }),
    style: (_ref2 = {}, (0,defineProperty/* default */.Z)(_ref2, '--padding', "".concat(padding, "px")), (0,defineProperty/* default */.Z)(_ref2, '--gap', "".concat(gap, "px")), (0,defineProperty/* default */.Z)(_ref2, '--line-offset', "".concat(Math.round(gap / 2), "px")), (0,defineProperty/* default */.Z)(_ref2, '--padding', "".concat(padding, "px")), _ref2),
    children: items.map(function (item, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: List_cx('item', liClassName, (0,defineProperty/* default */.Z)({
          withSeparator: line !== 'none' && index + 1 !== items.length
        }, "separator-".concat(line), line !== 'none')),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* Text */.x, {
          align: align,
          className: liClassName,
          color: color,
          opacity: opacity,
          size: size,
          tag: "div",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (List_module_default()).bulletWrapper,
            children: finalBullet
          }), item]
        })
      }, typeof item === 'string' ? item : index);
    })
  });
};

/***/ }),

/***/ 88358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ SmallTitle; }
/* harmony export */ });
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _SmallTitle_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61893);
/* harmony import */ var _SmallTitle_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_SmallTitle_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_0___default().bind((_SmallTitle_module_scss__WEBPACK_IMPORTED_MODULE_3___default()));
var SmallTitle = function SmallTitle(_ref) {
  var color = _ref.color,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'center' : _ref$align,
      className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("strong", {
    className: cx('title', color, align, className),
    children: children
  });
};

/***/ }),

/***/ 17023:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-cdn",
      function () {
        return __webpack_require__(22763);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61676:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","title":"CtaPanel_title__vfyTD","content":"CtaPanel_content__G8P1m","buttonsWrapper":"CtaPanel_buttonsWrapper__BKj4R","button":"CtaPanel_button__yWNke"};

/***/ }),

/***/ 19630:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","section":"CtaPanelWrapper_section__I_bFZ","background":"CtaPanelWrapper_background__jJEtB","linesBackground":"CtaPanelWrapper_linesBackground__G8nzf","content":"CtaPanelWrapper_content__2337f"};

/***/ }),

/***/ 12743:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","wrapper":"QuestionBox_wrapper__1E9z8","question":"QuestionBox_question__MqOHB","iconWrapper":"QuestionBox_iconWrapper__ogjcQ","isVisible":"QuestionBox_isVisible__5lfHr","answer":"QuestionBox_answer__5Nwrs","answerMargin":"QuestionBox_answerMargin__RGDdL","large":"QuestionBox_large__pFb4r","icon":"QuestionBox_icon__F9_bU"};

/***/ }),

/***/ 79320:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","faqWrapper":"FaqSection_faqWrapper__xjEah","faq":"FaqSection_faq__3QMjn"};

/***/ }),

/***/ 69993:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","wrapper":"Feature_wrapper__lbAlh","iconWrapper":"Feature_iconWrapper__39a01","md":"Feature_md__V0QK4","sm":"Feature_sm__HyZfE","title":"Feature_title__3NJpm","light":"Feature_light__lW3eg","dark":"Feature_dark__1CH_1","description":"Feature_description__JVoID"};

/***/ }),

/***/ 48543:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","list":"List_list__M0n5r","withSeparator":"List_withSeparator__MGrAD","item":"List_item__LcNFs","separator-light":"List_separator-light__PC4el","bulletWrapper":"List_bulletWrapper__2fkWE","counter":"List_counter__0Ne7o"};

/***/ }),

/***/ 12868:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"ListBullet_black__OWTRX","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","circle":"ListBullet_circle__sZqNP","square":"ListBullet_square__k1nCb","bordered":"ListBullet_bordered__BCHFX","inherit":"ListBullet_inherit__U3EPw","blue":"ListBullet_blue__YwsY_","yellow":"ListBullet_yellow__z1IBu","filled":"ListBullet_filled__BfC40"};

/***/ }),

/***/ 41029:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","wrapper":"MessageBar_wrapper__BHIAq"};

/***/ }),

/***/ 49661:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","row":"VideoCdn_row__0gQb2","link":"VideoCdn_link__M9JFE","isReversed":"VideoCdn_isReversed__8kVbQ","imageWrapper":"VideoCdn_imageWrapper__8imYZ"};

/***/ }),

/***/ 61893:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"SmallTitle_white__hR3LA","black":"#000","green400":"#3db462","gray100":"#f8f9fb","gray200":"#eeeeef","gray300":"#e2e3e4","gray400":"#a0a0a2","gray500":"#49494c","gray800":"#201f2c","gray900":"#0f0e1a","blue300":"#0d5284","blue700":"#00365c","blue800":"#002044","red100":"#ffddd8","red300":"#ff6d5e","red400":"#ec4545","yellow100":"#fff4e1","yellow200":"#f6d859","gridSpacingXs":"10px","gridSpacingSm":"20px","gridSpacingMd":"30px","gridSpacingLg":"40px","gridSpacingXl":"60px","gridSpacingXxl":"90px","title":"SmallTitle_title__PbCvY","blue":"SmallTitle_blue__5PFsZ","gray":"SmallTitle_gray__q1I8A","lightGray":"SmallTitle_lightGray__wwYf8","left":"SmallTitle_left__4a_JB","center":"SmallTitle_center__knDAe","right":"SmallTitle_right__Bzoc4"};

/***/ }),

/***/ 39582:
/***/ (function(module) {

module.exports = {
        srcSet: "/_next/static/images/cta-globe-640.871c58ec.webp"+" 640w"+","+"/_next/static/images/cta-globe-828.96761849.webp"+" 828w"+","+"/_next/static/images/cta-globe-1080.3b4d7404.webp"+" 1080w"+","+"/_next/static/images/cta-globe-1138.b02e952a.webp"+" 1138w",
        images: [{path: "/_next/static/images/cta-globe-640.871c58ec.webp",width: 640,height: 640},{path: "/_next/static/images/cta-globe-828.96761849.webp",width: 828,height: 828},{path: "/_next/static/images/cta-globe-1080.3b4d7404.webp",width: 1080,height: 1080},{path: "/_next/static/images/cta-globe-1138.b02e952a.webp",width: 1138,height: 1138}],
        src: "/_next/static/images/cta-globe-1138.b02e952a.webp",
        toString: function(){return "/_next/static/images/cta-globe-1138.b02e952a.webp"},
        
        width: 1138,
        height: 1138
      }

/***/ }),

/***/ 67137:
/***/ (function(module) {

module.exports = {
        srcSet: "/_next/static/images/hero-640.4a7c3356.webp"+" 640w"+","+"/_next/static/images/hero-828.0a03ea46.webp"+" 828w"+","+"/_next/static/images/hero-1080.dae1b1e3.webp"+" 1080w"+","+"/_next/static/images/hero-1154.e95f7933.webp"+" 1154w",
        images: [{path: "/_next/static/images/hero-640.4a7c3356.webp",width: 640,height: 433},{path: "/_next/static/images/hero-828.0a03ea46.webp",width: 828,height: 560},{path: "/_next/static/images/hero-1080.dae1b1e3.webp",width: 1080,height: 730},{path: "/_next/static/images/hero-1154.e95f7933.webp",width: 1154,height: 780}],
        src: "/_next/static/images/hero-1154.e95f7933.webp",
        toString: function(){return "/_next/static/images/hero-1154.e95f7933.webp"},
        
        width: 1154,
        height: 780
      }

/***/ }),

/***/ 78966:
/***/ (function(module) {

module.exports = {
        srcSet: "/_next/static/images/html5-player-640.47ed9471.webp"+" 640w"+","+"/_next/static/images/html5-player-828.a86f2725.webp"+" 828w"+","+"/_next/static/images/html5-player-1030.85a0c7fc.webp"+" 1030w",
        images: [{path: "/_next/static/images/html5-player-640.47ed9471.webp",width: 640,height: 496},{path: "/_next/static/images/html5-player-828.a86f2725.webp",width: 828,height: 641},{path: "/_next/static/images/html5-player-1030.85a0c7fc.webp",width: 1030,height: 798}],
        src: "/_next/static/images/html5-player-1030.85a0c7fc.webp",
        toString: function(){return "/_next/static/images/html5-player-1030.85a0c7fc.webp"},
        
        width: 1030,
        height: 798
      }

/***/ }),

/***/ 72570:
/***/ (function(module) {

module.exports = {
        srcSet: "/_next/static/images/ls-processing-640.34b6ec01.webp"+" 640w"+","+"/_next/static/images/ls-processing-828.4039eae8.webp"+" 828w"+","+"/_next/static/images/ls-processing-1080.ce6ef695.webp"+" 1080w"+","+"/_next/static/images/ls-processing-1118.59ad4168.webp"+" 1118w",
        images: [{path: "/_next/static/images/ls-processing-640.34b6ec01.webp",width: 640,height: 429},{path: "/_next/static/images/ls-processing-828.4039eae8.webp",width: 828,height: 555},{path: "/_next/static/images/ls-processing-1080.ce6ef695.webp",width: 1080,height: 725},{path: "/_next/static/images/ls-processing-1118.59ad4168.webp",width: 1118,height: 750}],
        src: "/_next/static/images/ls-processing-1118.59ad4168.webp",
        toString: function(){return "/_next/static/images/ls-processing-1118.59ad4168.webp"},
        
        width: 1118,
        height: 750
      }

/***/ }),

/***/ 31608:
/***/ (function(module) {

module.exports = {
        srcSet: "/_next/static/images/vod-workflow-640.caf6ee9f.webp"+" 640w"+","+"/_next/static/images/vod-workflow-828.f06b4df5.webp"+" 828w"+","+"/_next/static/images/vod-workflow-1080.c5b5e1f0.webp"+" 1080w"+","+"/_next/static/images/vod-workflow-1114.bb323c23.webp"+" 1114w",
        images: [{path: "/_next/static/images/vod-workflow-640.caf6ee9f.webp",width: 640,height: 345},{path: "/_next/static/images/vod-workflow-828.f06b4df5.webp",width: 828,height: 446},{path: "/_next/static/images/vod-workflow-1080.c5b5e1f0.webp",width: 1080,height: 582},{path: "/_next/static/images/vod-workflow-1114.bb323c23.webp",width: 1114,height: 600}],
        src: "/_next/static/images/vod-workflow-1114.bb323c23.webp",
        toString: function(){return "/_next/static/images/vod-workflow-1114.bb323c23.webp"},
        
        width: 1114,
        height: 600
      }

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5881,9517,9774,2888,179], function() { return __webpack_exec__(17023); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);